import { useSignUp } from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/context';
import { MAGIC_LINK_CALLBACK_URL } from 'consts';
import {
  CODE_VERIFY_ERROR,
  SIGNUP_EMAIL_SENT,
  SIGNUP_FAILED,
} from 'consts/analytics/onBoardingEvents';
import { SEND_TWO_FACTOR_AUTH } from 'graphql/mutations/sendTwoFactorAuth';
import { CHECK_USER_EXISTS } from 'graphql/user/mutations/useExist';
import { useAuthMutation } from 'hooks/api/graphql/auth';
import { analytics } from 'hooks/integrations/mixpanel/useMixpanel';
import { useEffect, useState } from 'react';
import { getRawNumber } from 'utils/formatters';

const useSignupConfirm = (onFinish: () => void, tenant: boolean) => {
  const [loading, setLoading] = useState(false);
  const [detailsExist, setDetailsExist] = useState(false);
  const { email, phoneNumber, isFormValid } = useSignUp();
  const [sendTwoFactorAuth] = useAuthMutation(SEND_TWO_FACTOR_AUTH, tenant);
  const [checkUserExists] = useAuthMutation(CHECK_USER_EXISTS, tenant);

  useEffect(() => {
    if (!isFormValid) setDetailsExist(false);
  }, [isFormValid]);

  const sendCode = async () => {
    const options = {
      variables: {
        authMethodType: 'email',
        identifier: email,
        callbackUrl: MAGIC_LINK_CALLBACK_URL,
      },
    };
    try {
      const response = await sendTwoFactorAuth(options);
      const { send2FA } = response.data;
      if (!send2FA.success) {
        analytics.track(CODE_VERIFY_ERROR, options);
      } else {
        analytics.track(SIGNUP_EMAIL_SENT);
      }
    } catch (e) {
      analytics.track(SIGNUP_FAILED, options);
    }
  };

  const onConfirm = async () => {
    setLoading(true);
    const { data } = await checkUserExists({
      variables: { email, mobile: getRawNumber(phoneNumber) },
    });
    if (!data?.checkUserExists?.data?.exists) {
      await sendCode();
      onFinish?.();
    } else {
      setDetailsExist(true);
    }
    setLoading(false);
  };

  return {
    onConfirm,
    loading,
    detailsExist,
  };
};

export default useSignupConfirm;
